import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Container,
  Title,
  CardsGrid,
  Card,
  CardCorner,
  CardTitle,
  StyledLink,
} from './EducationBlock.style';

import card1Src from '../../assets/images/education/education_type_1.png';
import card2Src from '../../assets/images/education/education_type_2.png';
import card3Src from '../../assets/images/education/education_type_3.png';
import card4Src from '../../assets/images/education/education_type_4.png';
import card5Src from '../../assets/images/education/education_type_5.png';
import card6Src from '../../assets/images/education/education_type_6.png';

export const EducationBlock = ({ excludePage = null }) => {
  const intl = useIntl();

  // Define all 6 education blocks
  const allEducationBlocks = [
    {
      id: 'business-education',
      title: intl.formatMessage({ defaultMessage: 'Business Education' }),
      titleWithBreak: (
        <FormattedMessage
          defaultMessage="Business{br}Education"
          values={{ br: <br /> }}
        />
      ),
      url: '/education/business-education',
      imageSrc: card1Src,
      color: '#e74391',
    },
    {
      id: 'in-salon-classes',
      title: intl.formatMessage({ defaultMessage: 'In-Salon Classes' }),
      titleWithBreak: (
        <FormattedMessage
          defaultMessage="In-Salon{br}Classes"
          values={{ br: <br /> }}
        />
      ),
      url: '/education/in-salon-classes',
      imageSrc: card3Src,
      color: '#9457a3',
    },
    {
      id: 'in-salon-artist-classes',
      title: intl.formatMessage({ defaultMessage: 'In-Salon Artist Classes' }),
      titleWithBreak: (
        <FormattedMessage
          defaultMessage="In-Salon{br}Artist Classes"
          values={{ br: <br /> }}
        />
      ),
      url: '/education/in-salon-artist-classes',
      imageSrc: card2Src,
      color: '#533fa4',
    },
    {
      id: 'education-on-demand',
      title: intl.formatMessage({ defaultMessage: 'Education On Demand' }),
      titleWithBreak: (
        <FormattedMessage defaultMessage="Education On Demand" />
      ),
      url: '/education/education-on-demand',
      imageSrc: card4Src,
      color: '#e1000f',
    },
    {
      id: 'academy-education',
      title: intl.formatMessage({ defaultMessage: 'Academy Education' }),
      titleWithBreak: (
        <FormattedMessage defaultMessage="Academy Education" />
      ),
      url: '/education/academy-education',
      imageSrc: card5Src,
      color: '#00a0df',
    },
    {
      id: 'events-experiences',
      title: intl.formatMessage({ defaultMessage: 'Events & Experiences' }),
      titleWithBreak: (
        <FormattedMessage
          defaultMessage="Events &{br}Experiences"
          values={{ br: <br /> }}
        />
      ),
      url: '/education/events-experiences',
      imageSrc: card6Src,
      color: '#8bc53f',
    },
  ];

  // Filter out only the current page and show remaining 5 blocks
  const displayedBlocks = allEducationBlocks.filter(
    (block) => block.id !== excludePage
  ).slice(0, 5);

  return (
    <Root>
      <Container>
        <Title>
          <FormattedMessage defaultMessage="Explore & Redeem" />
        </Title>
        <CardsGrid>
          {displayedBlocks.map((block) => (
            <Card key={block.id} to={block.url}>
              <img src={block.imageSrc} alt={block.title} />
              <CardCorner
                xmlns="http://www.w3.org/2000/svg"
                width={33}
                viewBox="0 0 67 60"
              >
                <path
                  d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z"
                  fill={block.color}
                ></path>
              </CardCorner>
              <CardTitle>{block.titleWithBreak}</CardTitle>
              <StyledLink style={{ color: block.color }}>
                <FormattedMessage defaultMessage="Get Started" />
              </StyledLink>
            </Card>
          ))}
        </CardsGrid>
      </Container>
    </Root>
  );
};
